import React, { useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import "./Content.css";
import Contact from "../Contact/Contact";
import MessageCard from "../Cards/messageCard";
import { useInView } from "react-intersection-observer";
import { NavLink } from "react-router-dom";
import SubjectCards from "./SubjectCard/SubjectCards";
import bullet_icon from "../../image/bullet_icon.svg";
import HouseAndClubs from "../BeyondCurrciular/HouseAndClubs";
import { Col, Row } from "react-bootstrap";
import Eventshappening from "../events/events";
import Inspired from "../Inspired/Inspired";

function ContentMain(props) {
  const {
    sidebar_data,
    data,
    title,
    alumni_data,
    curriculum_data,
    awards_data,
    news_data,
    side_heading,
    side_sub_heading,
    link,
    showBubble,
    headingColor,
    topicon,
    flaticon,
  } = props;
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true,
    delay: 100,
  });

  function GenericContentSection({ items }) {
    return (
      <div className="generic_content_list">
        {items?.map((item, index) => {
          const paragraphs = [
            item.description,
            ...(Array.isArray(item.extra_description)
              ? item.extra_description
              : []),
          ].filter(Boolean);
          const image = item.image || item.description_image?.[0];
          const subtitle = item.occ || item.occupation;

          return (
            <div
              key={item.id || index}
              className={`generic_content_item ${
                index % 2 === 0
                  ? "generic_content_item--normal"
                  : "generic_content_item--reverse"
              }`}
            >
              {image ? (
                <div className="generic_content_media">
                  <img
                    src={image}
                    alt={item.name || item.title || "content"}
                    className="generic_content_image"
                    style={{
                      border: `3px solid ${headingColor}`,
                      boxShadow: "10px 8px 4px rgba(0, 0, 0, 0.25)",
                    }}
                  />
                </div>
              ) : null}

              <div className="generic_content_body">
                {item.title ? (
                  <div className="f-bold f-1-2 mb-2">{item.title}</div>
                ) : null}
                {item.name ? (
                  <div className="generic_content_name">{item.name}</div>
                ) : null}
                {subtitle ? (
                  <div className="color-grey f-500 mb-3">{subtitle}</div>
                ) : null}
                {paragraphs.map((paragraph, paragraphIndex) => (
                  <p
                    key={`${item.id || index}-${paragraphIndex}`}
                    className="generic_content_paragraph"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  function Card({ data }) {
    return (
      <div className="card_main cursor">
        <div>
          <img
            src={data.image}
            alt="a-images"
            className="alumni_image"
            style={{
              boxShadow: "10px 8px 4px rgba(0, 0, 0, 0.25)",
              border: "3px solid",
              borderColor: headingColor,
            }}
          />
        </div>
        <div className="alumni_details">
          <div className="f-500 color-blue-cyan f-1">{data.title}</div>
          <div>
            <div>{data.occupation}</div>
          </div>
        </div>
      </div>
    );
  }
  function AwardCard({ data }) {
    return (
      <div className="card_main cursor award_card">
        <div>
          <img
            src={data.image}
            alt="a-images"
            className="award_image"
            style={{
              boxShadow: "10px 8px 4px rgba(0, 0, 0, 0.25)",
              border: "3px solid",
              borderColor: headingColor,
            }}
          />
        </div>
        <div className="alumni_details">
          <div className="f-500 color-blue-cyan f-1">{data.title}</div>
        </div>
      </div>
    );
  }
  function NewsCard({ data }) {
    return (
      <div className="card_main cursor award_card news_card">
        <div>
          <img
            src={data.image}
            alt="a-images"
            className="award_image"
            style={{
              boxShadow: "10px 8px 4px rgba(0, 0, 0, 0.25)",
              border: "3px solid",
              borderColor: headingColor,
            }}
          />
        </div>
      </div>
    );
  }
  function CurriculumCard({ data }) {
    return (
      <NavLink to={`/${data.navigation}`}>
        <div className="curriculum_card_main cursor">
          <div>
            <div style={{ maxWidth: "330px", maxHeight: "300px" }}>
              <img
                src={data.image}
                alt="c"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  aspectRatio: "16/9",
                  border: "3px solid #F91984ED",
                  boxShadow: "10px 8px 4px rgba(0, 0, 0, 0.25)",
                }}
              />
            </div>
            <div className="f-500 f-1-5 mt-3 text-center">{data.title}</div>
          </div>
          <div className="hover_content">
            <div>
              <p
                style={{
                  textAlign: "center",
                  color: "white",
                  margin: "1rem",
                }}
              >
                {data.text}
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "7rem",
                    height: "2.5rem",
                    backgroundColor: "none",
                    border: "3px solid #0076BD",
                    borderRadius: "5px",
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0.25rem",
                      color: "#0076BD",
                    }}
                  >
                    Know More
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </NavLink>
    );
  }

  return (
    <div className="contentmain_cont">
      <div style={{ width: "min-content" }}>
        <SideBar
          sidebar_data={sidebar_data}
          side_heading={side_heading}
          side_sub_heading={side_sub_heading}
        />
        <Contact />
      </div>
      {link == "clubs" ? (
        <div>
          {showBubble ? (
            <>
              <div
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "0 0 100px 100px",
                  marginLeft: "70%",
                  marginTop: "-8rem",
                  backgroundColor: "#0548CA73",
                  position: "absolute",
                  left: "8%",
                  zIndex: "-1",
                  top: "-0.2%",
                }}
              ></div>
              <div
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "0 0 100px 100px",
                  marginLeft: "78%",
                  marginTop: "-11rem",
                  backgroundColor: "#DA056B73",
                  position: "absolute",
                  left: "7%",
                  zIndex: "-1",
                  top: "1%",
                }}
              ></div>
            </>
          ) : null}

          <HouseAndClubs data={data} />
        </div>
      ) :link === "inspired" ? (
        <Inspired data={data}/>
      )  :link === "events" ? (
        <Eventshappening data={data}/>
      ) : link === "student-council" ||
        link === "ncc-scouts" ||
        link === "trips" ||        
        link === "primary" ? (
        <div className="speech">
          <div
            className={`f-2 f-500 color-blue-cyan`}
            style={{
              marginBottom: "1rem",
              color: headingColor,
            }}
          >
            {flaticon && (
              <img
                src={flaticon}
                style={{ width: "51px", margin: "2px 5px 0 0", height: "55px" }}
                alt=""
              />
            )}

            {title}
          </div>
          {data.map((item, i) => {
            return (
              <div
                className={`d-flex justify-content-between w-100 gap-4 mb-4 students_council ${
                  i % 2 === 0 ? "nondynamic" : "dynamic"
                }`}
              >
                <div style={{ flex: "3" }}>
                  <div
                    className="f-bold f-1-2 mb-2"
                    style={{
                      fontSize: 25,
                    }}
                  >
                    {item.title}
                  </div>
                  <div className="color-grey f-500">{item.description}</div>
                </div>

                {item.description_image && (
                  <div
                    style={{
                      flex: "1.8",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={item.description_image[0]}
                      className="content_rect_img"
                      style={{
                        border: `3px solid ${headingColor}`,
                        boxShadow: "10px 8px 4px rgba(0, 0, 0, 0.25)",
                        marginTop: "10px",
                      }}
                      alt=""
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div>
          {showBubble ? (
            <>
              <div
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "0 0 100px 100px",
                  marginLeft: "74%",
                  marginTop: "-7rem",
                  backgroundColor: "#FCF547B0",
                  position: "absolute",
                  left: "8%",
                  zIndex: "-1",
                  top: "-1.5%",
                }}
              ></div>
              <div
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "0 0 100px 100px",
                  marginLeft: "83.5%",
                  marginTop: "-11rem",
                  backgroundColor: "#FF69B487",
                  position: "absolute",
                  left: "5%",
                  zIndex: "-1",
                  top: "2.5%",
                }}
              ></div>
            </>
          ) : null}
          <div
            className={`f-2 f-500 color-blue-cyan`}
            style={{
              marginBottom: "0rem",
              color: headingColor,
              // marginTop: showBubble ? "-110px" : "0px",
            }}
          >
            <Row style={{ display: "flex", alignItems: "center" }}>
              {topicon ? (
                <Col xs={1}>
                  <img className={`admissionsimage`} src={topicon} alt="" />
                </Col>
              ) : null}
              {flaticon ? <Col xs={1}>{flaticon}</Col> : null}

              <Col className="title">{title}</Col>
            </Row>
          </div>         
          {curriculum_data ? (
            <div className="curriculum_main">
              {curriculum_data?.map((item, i) => {
                return <CurriculumCard data={item} />;
              })}
            </div>
          ) : null}
          {!curriculum_data && !awards_data && !news_data && data?.length ? (
            <GenericContentSection items={data} />
          ) : null}
          {awards_data ? (
            <div className="mt-4">
              {awards_data?.map((item, i) => {
                return <AwardCard data={item} />;
              })}
            </div>
          ) : null}
          {news_data ? (
            <div className="mt-3 news">
              {news_data?.map((item, i) => {
                return <NewsCard data={item} />;
              })}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}

export default ContentMain;
